module.exports = __webpack_public_path__ + "img/1.61dd17ee.jpg";